import React from 'react';

// Colors mirror the original Excel tracker so coordinators recognize it immediately (Task 8).
const STATUS_LABEL = {
  done: 'Done',
  blocked: 'Blocked',
  planned: 'Planned',
  not_started: 'Not Started',
  not_applicable: 'N/A',
};

export default function StepCell({ entry, editable, onClick }) {
  const status = entry?.status || 'not_started';
  const dateLabel = entry?.statusDate ? new Date(entry.statusDate).toLocaleDateString('en-GB', { day: '2-digit', month: 'short' }) : null;

  return (
    <td
      className={`step-cell step-cell--${status} ${editable ? 'step-cell--editable' : ''}`}
      onClick={editable ? onClick : undefined}
      title={entry?.comment || ''}
    >
      <span className="step-cell__label">{STATUS_LABEL[status]}</span>
      {dateLabel && <span className="step-cell__date">{dateLabel}</span>}
    </td>
  );
}
